import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Camera, Sparkles, Zap } from 'lucide-react';

export default function WasIstSnapshot() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-black grain-texture text-white">
      <div className="max-w-4xl mx-auto px-6 py-12">
        <button
          onClick={() => navigate('/welcome')}
          className="flex items-center gap-2 text-white/60 hover:text-white transition-colors mb-8"
        >
          <ArrowLeft className="w-5 h-5" />
          Zurück
        </button>

        <div className="space-y-8">
          <div className="flex items-center gap-4 mb-6">
            <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-[#10B981] to-[#059669] flex items-center justify-center glow-green">
              <Camera className="w-8 h-8 text-black" />
            </div>
            <h1 className="text-4xl md:text-5xl font-bold">Was ist Snapshot?</h1>
          </div>
          
          {/* Hero Text Box */}
          <div className="p-8 border-2 border-[#10B981]/30 rounded-2xl bg-[#10B981]/5 glow-green-soft">
            <h2 className="text-2xl md:text-3xl font-bold text-white mb-6">
              Willkommen bei SNAPSHOT.
            </h2>
            
            <div className="space-y-4 text-white/90 text-lg leading-relaxed">
              <p className="flex items-start gap-3">
                <span className="text-[#10B981] text-2xl">›</span>
                <span>Hier erschaffst du dein <span className="font-semibold text-white">digitales Ich</span>.</span>
              </p>
              
              <p className="flex items-start gap-3">
                <span className="text-[#10B981] text-2xl">›</span>
                <span>Trainiere deinen eigenen <span className="font-semibold text-white">Avatar</span> - so, wie du dich siehst.</span>
              </p>
              
              <p className="flex items-start gap-3">
                <span className="text-[#10B981] text-2xl">›</span>
                <span>Erstelle deine persönliche <span className="font-semibold text-white">ID Card</span> und teile sie mit der Welt.</span>
              </p>
              
              <p className="flex items-start gap-3">
                <span className="text-[#10B981] text-2xl">›</span>
                <span>Gestalte Bilder, Momente und Visionen, die dich repräsentieren.</span>
              </p>
              
              <div className="mt-6 pt-6 border-t border-white/10">
                <p className="text-xl font-bold text-[#10B981] mb-3">
                  SNAPSHOT ist deine digitale Identität - grenzenlos, individuell, echt.
                </p>
                <p className="text-base text-white/70">
                  Mit modernster KI-Technologie erstellen wir Avatare mit bis zu <span className="font-bold text-[#10B981]">95% Face-Match-Genauigkeit</span>.
                </p>
              </div>
            </div>
          </div>

          <div className="grid md:grid-cols-3 gap-6">
            <div className="p-6 border border-white/10 rounded-xl bg-white/5 hover:border-[#10B981]/30 transition-all">
              <Sparkles className="w-10 h-10 text-[#10B981] mb-4" />
              <h3 className="text-xl font-bold mb-2">KI-Technologie</h3>
              <p className="text-white/60 text-sm">
                Modernste AI-Modelle für realistische und kreative Ergebnisse
              </p>
            </div>

            <div className="p-6 border border-white/10 rounded-xl bg-white/5 hover:border-[#10B981]/30 transition-all">
              <Zap className="w-10 h-10 text-[#10B981] mb-4" />
              <h3 className="text-xl font-bold mb-2">Schnell & Einfach</h3>
              <p className="text-white/60 text-sm">
                In wenigen Schritten zu deinem persönlichen Avatar
              </p>
            </div>

            <div className="p-6 border border-white/10 rounded-xl bg-white/5 hover:border-[#10B981]/30 transition-all">
              <Camera className="w-10 h-10 text-[#10B981] mb-4" />
              <h3 className="text-xl font-bold mb-2">Vielseitig</h3>
              <p className="text-white/60 text-sm">
                Unzählige Stile und Variationen für jeden Einsatzzweck
              </p>
            </div>
          </div>

          {/* Full-Width Banner am Ende */}
          <div className="mt-12 -mx-6 p-8 md:p-12 bg-gradient-to-r from-[#10B981]/10 via-[#10B981]/20 to-[#10B981]/10 border-y-2 border-[#10B981]/30 glow-green-soft">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-black text-center text-[#10B981] tracking-tight">
              Deine digitale Identität startet hier.
            </h2>
          </div>
        </div>
      </div>
    </div>
  );
}